import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  public emailSubject: string =
    'RE: Enterprise Cross Ref Consumption Application';
  public emailBody: string =
    'Please provide a detailed explanation of your feedback or problem with the Enterprise Cross-Reference Consumption Application. Thank you.';
  public emailAddress: string = 'servicedesk@vizientinc.com';

  public mailToTag: string = '';

  constructor() {
    this.mailToTag =
      'mailto:' +
      this.emailAddress +
      '?subject=' +
      this.emailSubject +
      ' &body=' +
      this.emailBody;
  }
}
